// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  worldId: __t.u64().primaryKey().name("world_id"),
  template: __t.string(),
  authorship: __t.string(),
  jurisdiction: __t.string(),
  capacity: __t.u32(),
  quarantined: __t.bool(),
  platformLocked: __t.bool().name("platform_locked"),
  legacyProtected: __t.bool().name("legacy_protected"),
  visitorCount: __t.u32().name("visitor_count"),
  verifiedReports: __t.u32().name("verified_reports"),
  archivedAt: __t.timestamp().name("archived_at"),
  seasonStartedAt: __t.timestamp().name("season_started_at"),
  royaltyBps: __t.u32().name("royalty_bps"),
  updatedAt: __t.timestamp().name("updated_at"),
});
